import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import styles from './UserProfile.module.css'
import usericon from '../../assets/icons/user.svg'
import bellicon from '../../assets/icons/bell.svg'
import arrowicon from '../../assets/icons/arrow.svg'
import { getAccessToken } from '../Auth/AuthStore.ts'
import { clearAccessToken } from '../Auth/AuthStore.ts'

const UserProfile = () => {
  const navigate = useNavigate()
  const [username, setUsername] = useState('') 
  const [nickname, setNickname] = useState('')
  const [showProfileDropdown, setShowProfileDropdown] = useState(false)
  const [loadingDots, setLoadingDots] = useState('.')
  const [profileImage, setProfileImage] = useState(null)
  const dropdownRef = useRef(null)
  const arrowButtonRef = useRef(null)

  useEffect(() => {
    const fetchUserData = async () => {
      try {

        const token = getAccessToken();
        if (!token) throw new Error('JWT 발급 실패: token 없음');

        const response = await axios.get(`${import.meta.env.VITE_API_BASE}/api/user/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }, 
        })

        const userData = response.data.data

        setUsername(userData.username)
        setNickname(userData.nickname)
        setProfileImage(userData.profileImageUrl || null)
      } catch (error) {
        console.error('유저 정보를 불러오는데 실패했습니다:', error)
      }
    }

    fetchUserData()
  }, [])

  // 불러오는 중 점 애니메이션
  useEffect(() => {
    if (!nickname) {
      const interval = setInterval(() => {
        setLoadingDots((prev) => {
          if (prev === '.') return '..'
          if (prev === '..') return '...'
          return '.'
        })
      }, 500) // 0.5초마다 변경

      return () => clearInterval(interval)
    }
  }, [nickname])
  
  const toggleProfileDropdown = (e) => {
    setShowProfileDropdown((prev) => !prev)
  }

  const handleNotificationClick = () => {
    alert('준비 중입니다.')
  }
  
  // 외부 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowProfileDropdown(false)
        if (arrowButtonRef.current) arrowButtonRef.current.blur()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])
  
  // ESC로 닫기
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        setShowProfileDropdown(false)
        if (arrowButtonRef.current) arrowButtonRef.current.blur()
      }
    }
    document.addEventListener('keydown', handleEscKey)
    return () => document.removeEventListener('keydown', handleEscKey)
  }, [])

  useEffect(() => {
    if (!showProfileDropdown && arrowButtonRef.current) {
      arrowButtonRef.current.blur()
    }
  }, [showProfileDropdown])

  const handleNavigate = (path) => {
    setShowProfileDropdown(false)

    navigate(path)
  }

  const handleLogout = async () => {
    setShowProfileDropdown(false) 

    try {
      const token = getAccessToken();
      if (!token) throw new Error('JWT 발급 실패: token 없음');


      await axios.post(
        `${import.meta.env.VITE_API_BASE}/api/user/logout`,
        null,
        {
          withCredentials: true, 
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      
      clearAccessToken()
  
      navigate('/') 
      
    } catch (error) {
      console.error(
        '로그아웃 실패:',
        error.response?.status,
        error.response?.data || error
      )
    }
  }

  return (
    <div className={styles.userProfile}>

      {/* 알림 버튼 */}
      {/*<div className={styles.notifications}>
        <button className={styles.notificationButton}
          onClick={handleNotificationClick}
        >
          <img src={bellicon} alt = "벨아이콘" draggable={false}/>
          <span className={styles.notificationBadge}>8</span>
        </button>
      </div>*/}

      {/* 유저 정보 버튼 */}
      <div className={styles.profileIcon}>
        <div className={styles.profileButton}>
          <img
            src={profileImage || usericon}
            alt="유저아이콘"
            draggable={false}
            className={profileImage ? styles.profileAvatar : ''}
          />
        </div>
      </div>

      {/* 유저 아이디 */}
      <div className={styles.username}>
        {nickname ? nickname : (
          <>
            로딩 중<span className={styles.loadingDots}>{loadingDots}</span>
          </>
        )}
      </div>
      
      {/* 화살표 */}
      <div className={styles.arrowContainer} ref={dropdownRef}>
        <button
          className={styles.arrowButton}
          aria-haspopup="menu"
          aria-expanded={showProfileDropdown}
          onClick={toggleProfileDropdown}
          ref={arrowButtonRef}
        >
          <img src={arrowicon} alt="화살표아이콘" draggable={false} />
        </button>

        {showProfileDropdown && (
          <div className={styles.profileDropdown} role="menu">
            <div className={styles.dropdownItem} role="menuitem">
              <span className={styles.dropdownIcon}>✦</span>
              {username}님
            </div>
            <button
              className={styles.dropdownItem}
              role="menuitem"
              onClick={() => handleNavigate('/profile')}
            >
              내 정보
            </button>
            <button
              className={styles.dropdownItem}
              role="menuitem"
              onClick={() => handleNavigate('/gallery')}
            >
              내 분석결과
            </button>
            <button
              className={styles.dropdownItem}
              role="menuitem"
              onClick={() => handleNavigate('/help')}
            >
              도움말
            </button>
            <button
              className={styles.dropdownItem}
              role="menuitem"
              onClick={handleLogout}
            >
              로그아웃
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default UserProfile